import React, { useState, useEffect, Fragment, useCallback } from 'react';
import {
    Card, CardBody, Button, TabContent, TabPane, NavItem, CardHeader, Nav, Row,
    UncontrolledDropdown,
    DropdownMenu,
    Input,
    CustomInput,
    ModalFooter,
    Modal, ModalBody, ModalHeader
} from 'reactstrap';
import { useDropzone } from 'react-dropzone'
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { API_Documents_Upload } from '../../../../../constants/APIs';


function DocumentUpload({ propertyId, SelectedDocument, togglegallery, hideUserUploads, searchText, uploadLink }) {

    if (hideUserUploads === undefined) {
        hideUserUploads = false;
    }
    if (searchText === undefined) {
        searchText = '';
    }

    const [activeTab, setActiveTab] = useState('embed');
    const [visible, setVisible] = useState(false);

    const toggle = () => {
        setVisible(!visible);
    }
    const toggleAppMenu = tab => {
        setActiveTab(tab)
    };


    const fileObj = [];
    const handleSubmit = () => {
        if (isAgree && isCheck) {
            const data = new FormData();
            files.forEach(file => {
                data.append('files', file.img);
                data.append('tags', file.tags)
                data.append('captions', file.caption)
            });
            data.append('propertyId', propertyId)
            data.append('groupId', getGroupID());
            data.append('creator', 'dashboard');
            console.log(JSON.stringify(data));

            // setApiState("processing")
            AxiosAPI({
                method: 'post',
                url: `${API_Documents_Upload}`,
                data: data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(
                res => {
                    console.log(res, res.data)
                    uploadLink(res);
                    togglegallery();
                    // setApiState('success')
                    // toggleModal();
                    // parentLoadData();
                },
                error => {
                    //  setApiState('fail')
                    console.log('eee.data', error.data);
                }
            );
        }
    };
    const [files, setFiles] = useState([]);
    const [isAgree, setAgree] = useState(false);
    const [isCheck, setIsCheck] = useState(false);
    const [errorModal, showErrorModal] = useState(false);
    const [ApiState, setApiState] = useState('default');
    const { getRootProps, getInputProps } = useDropzone({
        //accept: 'image/*',
        // accept: 'image/*,font/*',                              
        onDrop: acceptedFiles => {
            acceptedFiles.map(file => {
                console.log(file, file.name.includes('txt'));
                if (file.name.includes('txt') || file.name.includes('docx')) {
                    fileObj.push(
                        {
                            img: Object.assign(file, {
                                preview: URL.createObjectURL(file)
                            }),
                            tags: [],
                            caption: ''
                        });
                } else {
                    toggle();
                }
            });
            setFiles([...files, ...fileObj]);
        }
    });








    return (
        <Fragment>
            <CardHeader className="pl-0 pr-0">
                <Nav tabs className="card-header-tabs ml-0 mr-0">

                    <NavItem className="w-100 text-center">
                        <NavLink
                            className={classnames({
                                active: activeTab === "embed",
                                "nav-link": true
                            })}
                            onClick={() => {
                                toggleAppMenu("embed");
                            }}
                            to="#"
                        >
                            My Uploads
                        </NavLink>
                    </NavItem>
                </Nav>
            </CardHeader>

            <TabContent
                activeTab={activeTab}
                className=""
            >
                <TabPane tabId="embed" className="chat-app-tab-pane">
                    <Card className="mb-4">
                        <CardBody>
                            <Row className="mt-3">
                                <Colxx xxs="12">
                                    <Fragment>
                                        <Row className="mb-4">
                                            <section className="container">
                                                <div {...getRootProps({ className: 'dropzone' })}>
                                                    <input {...getInputProps()} />
                                                    <div class="dz-default dz-message">
                                                        <span>Drop files here to upload, or click to select files. Recommended upload limit of 10mb per file. Supported formats: JPEG, PNG, GIF, WEBP, SVG.

                                                        </span>
                                                        <p className="font-weight-medium mb-0 ">
                                                            <i className="demo-icon simple-icon-cursor-move"></i>
                                                        </p>
                                                    </div>

                                                </div>
                                                <div className="filepicker dropzone-gallery dz-clickable dz-started" style={{ minHeight: '100px', border: '0px' }}
                                                >
                                                    {files.map((file, index) => (
                                                        <div className="dz-preview dz-file-preview mb-3" key={index} style={{ height: '100px' }}>
                                                            <div className="row">
                                                                <div className="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                                                                    <div>
                                                                        {" "}
                                                                        <span data-dz-name>{file.img.name}</span>{" "}
                                                                    </div>
                                                                    <div className="text-primary text-extra-small" data-dz-size>{file.img.size}</div>
                                                                </div>

                                                            </div>

                                                            {/* <a href="#/" className="remove" data-dz-remove
                                                                onClick={() => handleRemoveFields(index)}
                                                            >
                                                                {" "}
                                                                <i className="glyph-icon simple-icon-trash" />{" "}
                                                            </a> */}
                                                        </div>

                                                    ))}
                                                </div>
                                            </section>
                                        </Row>
                                        <div className='d-flex text-center ml-0 font-weight-bold mt-1 mb-2' style={{ justifyContent: 'center' }}>
                                            <CustomInput
                                                type="checkbox"
                                                id="agree"
                                                value={isAgree}
                                                checked={isAgree}
                                                onChange={(e) => {
                                                    setAgree(!isAgree);
                                                }}
                                            >
                                                <span className='mt-1' style={{ verticalAlign: 'sub' }}>I have copyright or permissions to use this document.</span>

                                            </CustomInput>
                                        </div>
                                        <div className='d-flex text-center ml-0 font-weight-bold mt-1 mb-2' style={{ justifyContent: 'center' }}>
                                            <CustomInput
                                                type="checkbox"
                                                id="agree"
                                                value={isCheck}
                                                checked={isCheck}
                                                onChange={(e) => {
                                                    setIsCheck(!isCheck);
                                                }}
                                            >
                                                <span className='mt-1' style={{ verticalAlign: 'sub' }}>This document does not contain any personally identifiable information.</span>

                                            </CustomInput>
                                        </div>
                                        <div className='mt-2 d-flex' style={{ justifyContent: 'center' }}>
                                            <Button color="primary" onClick={handleSubmit}
                                                className={`btn-multiple-state text-white ${classnames(
                                                    {
                                                        "show-spinner": ApiState === "processing",
                                                        "show-success": ApiState === "success",
                                                        "show-fail": ApiState === "fail"
                                                    }
                                                )}`}
                                            >
                                                <span className="spinner d-inline-block">
                                                    <span className="bounce1" />
                                                    <span className="bounce2" />
                                                    <span className="bounce3" />
                                                </span>
                                                <span className="icon success">
                                                    <i className="simple-icon-check" />
                                                </span>
                                                <span className="icon fail">
                                                    <i className="simple-icon-exclamation" />
                                                </span>
                                                <span className="label">Save</span>
                                            </Button>

                                        </div>
                                    </Fragment>
                                </Colxx>
                            </Row>
                        </CardBody>
                    </Card>
                </TabPane>
            </TabContent>
            <Modal isOpen={visible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                    Document
                </ModalHeader>
                <ModalBody>
                    <h6 className='m-2'>
                        Invalid document, please upload .txt or .docx document.
                    </h6>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="ml-2"
                        color="dark"
                        outline
                        size="xs"
                        onClick={toggle}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, email } = settings;
    return {
        propertyId, email
    };
};

export default injectIntl(connect(mapStateToProps, {})(DocumentUpload));
